import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables/icons';
import { defaultLayoutComponents, defaultLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';
import { useAuthorizationStore } from '~/stores';

const ManageTemplatesRoute: RouteRecordRaw = {
	path: '/manage-templates',
	name: ROUTE_KEYS.MANAGE_TEMPLATES,
	meta: {
		label: 'manage-templates.page-title',
		auth: true,
		isFixedEntry: true,
		icon: () => $i('table'),
		isAuthorized: () => {
			const { hasConfigurableTemplates } = storeToRefs(useAuthorizationStore());
			return computed(() => hasConfigurableTemplates.value);
		}
	},
	props: {
		...defaultLayoutProps
	},
	components: {
		default: () => import('./manage-templates.page.vue'),
		...defaultLayoutComponents
	}
};

export default ManageTemplatesRoute;
